<template>
  <div class="HKInex_page">
    <div class="bg_page" :style="{ backgroundImage: `url('${list.bg}')` }">
      <div
        class="main_info ani"
        swiper-animate-effect="fadeInUp"
        swiper-animate-duration="2s"
        swiper-animate-delay="0s"
      >
        <div class="main_info_img" v-if="list.info">
          <img :src="`${list.info}`" alt="" />
        </div>
        <div v-else class="main_info_text">
          <div class="">
            <span>{{ list.text.cn }}</span
            >金融
          </div>
          <div class="main_info_text_en">{{ list.text.en }}</div>
        </div>
      </div>
      <div class="page_pagintion">
        <!-- 分页序号 -->
        <!-- <div class="pagintion_pages">
          <div
            class="ani flipm"
            swiper-animate-effect="flipInX"
            swiper-animate-duration="2s"
            swiper-animate-delay="0s"
          >
            {{ "0" + index }}
          </div>
          <div class="">/04</div>
        </div> -->

        <div class="arrow_down">
          <lottie
            :options="defaultOptions"
            :height="114"
            :width="114"
            @animCreated="handleAnimation"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lottie from "vue-lottie";
import arrowDown from "../assets/arrow_down.json";
export default {
  props: {
    index: {
      type: Number,
      default: 1,
    },
    list: [],
  },
  components: {
    lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: arrowDown },
    };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: PangMenZhengDao;
  src: url("../assets/fonts/PangMenZhengDao.TTF") format("truetype");
}
.HKInex_page {
  width: 100%;
  height: 100%;
}
.bg_page {
  width: 100%;
  height: 100%;
  padding: 88px;
  padding-bottom: 63px;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.main_info {
  width: 100%;
  height: 115px;
  margin-top: 360px;
  display: flex;
  justify-content: end;
  .main_info_img {
    width: 100%;
    height: 115px;
  }
  img {
    width: 852px;
    height: 115px;
  }

  .main_info_text {
    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    font-weight: bold;
    font-size: 51px;
    color: #d43030;
    line-height: 35px;
    text-align: left;
    margin-right: 100px;
  }
  span{
    color: #1C1C1C;
  }
  .main_info_text_en {
    font-family: MessapiaBlod, sans-serif;
    font-size: 22px;
    color: #1c1c1c;
    line-height: 34px;
    text-align: left;
    margin-top: 18px;
  }
}
.page_pagintion {
  position: absolute;
  left: 88px;
  bottom: 70px;
  width: 929px;
  height: 114px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;

  .pagintion_pages {
    font-family: PangMenZhengDao, sans-serif;
    display: flex;
    align-items: center;
    width: 296px;
    font-size: 54px;
    color: #292929;
    font-weight: 400;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .flipm {
    font-size: 72px;
    width: 105px;
    color: #c71723;
  }

  .arrow_down {
    width: 114px;
    height: 114px;
  }
}
</style>